var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.4999,
    height: 19.5001,
    viewBox: "0 0 19.4999 19.5001",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.39612 13.46C4.97114 12.6199 4.74984 11.6915 4.75012 10.75C4.75012 7.53502 7.25012 5.25002 10.7501 4.75002C14.8321 4.16702 16.5831 1.91702 17.7501 0.750017C21.2501 13.75 14.7501 16.75 10.7501 16.75C9.69697 16.7503 8.66231 16.4733 7.75012 15.947",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0.750117 18.75C1.25012 15.75 3.20812 13.886 7.75012 12.75C10.9671 11.946 13.2131 9.93002 14.7501 7.80502",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/leaf.fb7b149b098310c07342c76914981803.svg";
export { ForwardRef as ReactComponent };